import { render, staticRenderFns } from "./questionBank_info_list_set_type_4.vue?vue&type=template&id=985bf12e&scoped=true"
import script from "./questionBank_info_list_set_type_4.vue?vue&type=script&lang=js"
export * from "./questionBank_info_list_set_type_4.vue?vue&type=script&lang=js"
import style0 from "./questionBank_info_list_set_type_4.vue?vue&type=style&index=0&id=985bf12e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985bf12e",
  null
  
)

export default component.exports